<div class="editor">
  <ngx-editor-menu class="custom-editor-toolbar" [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>

  <ngx-editor [dir]="dir" [editor]="editor" [(ngModel)]="content" (ngModelChange)="onContentChange($event)">
  </ngx-editor>
</div>
